module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_photowedding@2x-7ca242fe409c5900df908839c924f28f.webp";